import { render, staticRenderFns } from "./CRUDTableStaffReviewer.vue?vue&type=template&id=0d353e29"
import script from "./CRUDTableStaffReviewer.vue?vue&type=script&lang=js"
export * from "./CRUDTableStaffReviewer.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableStaffReviewer.vue?vue&type=style&index=0&id=0d353e29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports